<template>
    <div>
        <datatable :isLoading.sync="datatable.isLoading"
                   :columns="datatable.columns"
                   :rows="datatable.rows"
                   :total="datatable.total"
                   :queryParams="datatable.queryParams"
                   @on-page-change="onPageChange"
                   @on-sort-change="onSortChange"
                   @on-per-page-change="onPerPageChange"
                   v-show="datatable.showTable"
        >
        </datatable>

        <CommonModal ref="showFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
            <template v-slot:CommonModalTitle>
                {{editMode ? $t('update').toUpper() : $t('detail').toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <ExaminationDetailsModal v-if="formProcess==='showModal'" @closeDetailModal="closeDetailModal" :editMode="editMode" :selectedId="selectedId"/>
            </template>
        </CommonModal>
    </div>
</template>
<script>
import qs from "qs";
import InfirmaryServices from "@/services/InfirmaryServices";
import ExaminationDetailsModal from "@/modules/infirmary/pages/ExaminationDetailsModal.vue";
import {EventBus} from "@/main";

export default {
    name: "PatientHistory",
    components: {ExaminationDetailsModal},
    props:{
      formId:{
          type:Number
      },
    },
    data(){
        return {
            editMode:false,
            selectedId:null,
            formProcess:null,
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('update'),
                                class: 'ri-edit-box-line',
                                permission: "infirmaryrecord_showinfirmaryrecord",
                                callback: (row) => {
                                    this.editMode=true
                                    this.showFormModal(row.id)
                                }
                            },

                            {
                                text: this.$t('show'),
                                class: 'ri-search-eye-line',
                                permission: "infirmaryrecord_showinfirmaryrecord",
                                callback: (row) => {
                                    this.showFormModal(row.id)
                                }
                            },
                            {
                                text: this.$t('delete'),
                                class: 'ri-delete-bin-2-line',
                                permission: "infirmaryrecord_deleteinfirmaryrecord",
                                callback: (row) => {
                                    this.deleteModal(() => {
                                        InfirmaryServices.del(row.id)
                                            .then(response => {
                                                this.$toast.success(this.$t('api.' + response.data.message));
                                                this.getRows();
                                            })
                                            .catch(error => {
                                                this.$toast.error(this.$t('api.' + error.data.message));
                                            });
                                    });
                                },
                            },
                            {
                                text: this.$t('examination_report'),
                                class: 'ri-file-chart-line',
                                permission: "infirmaryrecord_deleteinfirmaryrecord",
                                callback: (row) => {
                                    this.downloadReport(row.id)
                                },
                            },
                        ]
                    },
                    {
                        label: this.toUpperCase('id'),
                        field: 'id',
                        hidden: true,
                    },

                    {
                        label: this.toUpperCase('protocol_number'),
                        field: 'protocol_number',
                        hidden: false,
                        sortable: false,
                    },
                    // {
                    //     label: this.toUpperCase('complaint'),
                    //     field: 'complaint',
                    //     hidden: false,
                    //     sortable: false,
                    // },

                    {
                        label: this.toUpperCase('control_date'),
                        field: 'control_date',
                        hidden: false,
                        sortable: false,
                        formatFn:(row)=>{
                            return  row?this.toLocaleDateTime(row):null
                        }
                    },
                    // {
                    //     label: this.toUpperCase('diagnosis'),
                    //     field: 'diagnosis',
                    //     hidden: false,
                    //     sortable: false
                    // },
                    // {
                    //     label: this.toUpperCase('findings'),
                    //     field: 'findings',
                    //     hidden: false,
                    //     sortable: false
                    // },
                    {
                        label: this.toUpperCase('examination_date'),
                        field: 'medical_examination_date',
                        hidden: false,
                        sortable: false,
                        formatFn:(row)=>{
                            return row?this.toLocaleDateTime(row):null
                        }
                    },
                    // {
                    //     label: this.toUpperCase('result'),
                    //     field: 'result',
                    //     hidden: false,
                    //     sortable: false
                    // },
                    // {
                    //     label: this.toUpperCase('story'),
                    //     field: 'story',
                    //     hidden: false,
                    //     sortable: false
                    // },
                    // {
                    //     label: this.toUpperCase('treatment'),
                    //     field: 'treatment',
                    //     hidden: false,
                    //     sortable: false
                    // },
                    {
                        label: this.toUpperCase('visit_date'),
                        field: 'visit_date',
                        hidden: false,
                        sortable: false,
                        formatFn:(row)=>{
                            return row?this.toLocaleDateTime(row):null
                        }
                    },
                    {
                        label: this.toUpperCase('control_building'),
                        field: 'control_building_name',
                        hidden: false,
                        sortable: false,
                    }

                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {
                        infirmary_user_id:this.formId
                    },
                    sort: '-medical_examination_date',
                    page: 1,
                    limit: 10
                }
            },
        }

    },
    created() {
        this.getRows()
    },
    methods:{
        formClear() {
            this.formProcess = null
            this.editMode=false
            this.selectedId=null
        },
        filterSet() {
            this.datatable.queryParams.filter = {
                infirmary_user_id:this.formId
            }
        },
        filterClear() {
            this.filterSet();
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        changeColumn(key) {
            this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            return InfirmaryServices.getInfirmaryRecords(config).then(response => {
                this.datatable.rows = response.data.data
                this.datatable.total = response.data.pagination.total
            })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        showFormModal(id) {
            this.selectedId=id
            this.formProcess = 'showModal'
            this.$refs.showFormModal.$refs.commonModal.show()
        },
        closeDetailModal(){
            this.selectedId=null
            this.formProcess=null
            this.editMode=false
            this.$refs.showFormModal.$refs.commonModal.hide()
            this.getRows()
        },
       async downloadReport(id){
            try {
                const response = await InfirmaryServices.downloadReport(id)
                EventBus.$emit('pdfViewerModalShow', {pdfFileData: response.data, pdfFileName: this.$t('examination_report')});
            }catch (err){
                this.showErrors(err)
            }
        }

    }
}
</script>

<style scoped>

</style>
